import loginTemplateUrl from './login.tpl.html';

export default {
    templateUrl: loginTemplateUrl,
    controller: 'LoginController',
};
